<template>
    <rkm-overlay>
        <div
            v-if="items"
            class="conteudo"
        >
            <div class="parte-superior">
                <div>
                    <p>
                        <span>Senha:</span>
                        <strong>{{ items.length > 0 ? items[0].senha : null }}</strong>
                    </p>
                </div>

                <div>
                    <p>
                        <span>Nome:</span>
                        <strong>
                            {{ items.length > 0 ? getNome(items[0]) : null }}
                        </strong>
                    </p>
                </div>

                <div>
                    <p>
                        <span>Local:</span>
                        <strong>{{ items.length > 0 ? items[0].sala.nome : null }}</strong>
                    </p>
                </div>
            </div>

            <div
                v-if="items.length > 1"
                class="parte-inferior"
            >
                <h3>Últimas Chamadas</h3>

                <div
                    v-for="(tela_id, i) in items"
                    v-bind:key="i"
                >
                    <p v-if="items[i+1]">
                        <span class="senha">Senha: <strong>{{ items[i + 1].senha }}</strong></span>
                        <span class="nome">Nome: <strong>
                            {{ getNome(items[i + 1]) }}</strong>
                        </span>
                        <span class="local">Local: <strong>{{ items[i + 1].sala.nome }}</strong></span>
                    </p>
                </div>
            </div>
        </div>
    </rkm-overlay>
</template>

<script>
// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

// Mixins.
import { error, object, repository, stringCase } from '@/mixins'

// Assets.
import sound from '@/assets/sounds/painel-senha/tela/efeito.wav'

export default {
    computed: {
        ...mapGetters({ customer: 'getCustomer' }),
        items() {
            const model = this.clone(this.model)
            return model.sort((a, b) => b.id - a.id).slice(0, 4)
        },
    },
    created() {
        this.repositories = {
            tela: this.getConectaSusRepository('painelSenha.tela')
        }
    },
    data: () => ({
        enums: { preferenciaNome },
        loaded: false,
        model: [],
        sound,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        init() {
            const modulos = Array.isArray(this.$route.query.modulos) ? this.$route.query.modulos : [this.$route.query.modulos]
            const channel = this.pusher.subscribe(`private-${this.customer.link}-painel-senha-chamada`)

            modulos.forEach(modulo => {
                channel.bind(`${this.id}.${modulo}.updated`, (data) => {
                    const chamadas = this.snakeObjectKeysToCamelRecursive(data.chamadas)

                    chamadas.forEach(chamada => {
                        if (!this.model.find(model => model.id === chamada.id)) {
                            this.model.push(chamada)
                        }
                    })
                })
            })
        },
        load() {
            let request = {
                listar: 'chamadas',
                tela_id: this.id,
                modulo_ids: Array.isArray(this.$route.query.modulos) ? this.$route.query.modulos : [this.$route.query.modulos],
            }

            this.setLoading()

            this.repositories.tela.list(request)
                .then(response => {
                    this.model = response.data.model
                    this.$nextTick().then(() => this.loaded = true)
                })
                .catch(error => this.handleError(error))
                .finally(() => this.unsetLoading())
        },
        play() {
            const sound = new Audio(this.sound)
            sound.play()
        },
        getNome(model) {

            return model.paciente.cidadao.preferenciaNomeId == this.enums.preferenciaNome.NOME_SOCIAL
                ? model.paciente.cidadao.nomeSocial : model.paciente.cidadao.nome
        }
    },
    mixins: [ error, object, repository, stringCase ],
    mounted() {
        this.init()
        this.load()
    },
    props: {
        id: { type: Number, default: null }
    },
    watch: {
        items: function(value) {
            if (this.loaded) {

                const synth = window.speechSynthesis

                this.play()

                setTimeout(() => {
                    const senha = value[0].senha
                    const nome = this.getNome(value[0])
                    const sala = value[0].sala.nome

                    const message = `Senha ${senha}`
                        + (nome ? `, ${nome}, ` : '')
                        + (sala ? `comparecer ao local ${sala}` : '')

                    var toSpeak = new SpeechSynthesisUtterance(message)

                    toSpeak.voice = synth.getVoices().find(v => v.name === 'Microsoft Daniel - Portuguese (Brazil)	pt-BR')

                    synth.speak(toSpeak)
                }, 4300)
            }
        },
    },
}
</script>

<style scoped>
.conteudo {
    display: flex;
    flex-direction: column;
    height: 96vh;
    margin: 2vh 2%;
    width: 96%;
}
.parte-superior {
    background-color: khaki;
    display: flex;
    flex-direction: column;
    flex: 1;
    margin-bottom: 1vh;
    padding: 1%;
    width: 100%;
}
.parte-superior > div {
    background-color: white;
    border: 1px solid #D4D4D4;
    display: flex;
    flex-direction: column;
    flex: 1;
    justify-content: center;
    padding: 0 1%;
}
.parte-superior > div > p {
    display: block;
    font-size: 8vh;
    margin: 0;
}
.parte-superior > div > p > span {
    display: inline-block;
    width: 15%;
}
.parte-superior > div > p > strong {
    display: inline-block;
    width: 85%;
}
.parte-inferior {
    background-color: royalblue;
    display: flex;
    flex-direction: column;
    margin-top: 1vh;
    max-height: 40vh;
    padding: 2vh;
    width: 100%;
}
.parte-inferior > h3 {
    color: white;
}
.parte-inferior > div {
    background-color: white;
    border: 1px solid #D4D4D4;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0px 5px;
}
.parte-inferior > div > p {
    font-size: 3vh;
    margin: 0px;
}
.parte-inferior > div > p > .senha {
    display: inline-block;
    width: 15%;
}
.parte-inferior > div > p > .nome {
    display: inline-block;
    width: 55%;
}
.parte-inferior > div > p > .local {
    display: inline-block;
    text-align: right;
    width: 30%;
}
</style>